import { FC } from 'react';
import * as React from 'react';

import { clsx } from 'clsx';

import { Col, Row } from '@crehana/ui';
import { useUITheme } from '@crehana/web';
import { CourseEnrollmentCardSkeleton } from '@crehana/web/components/Cards/CourseEnrollmentCard';

const CourseListSkeleton: FC<
  React.PropsWithChildren<{ 'data-testid'?: string }>
> = ({ 'data-testid': dataTestId }) => {
  const { isDark } = useUITheme();

  return (
    <Row gutter={16} data-testid={dataTestId}>
      {Array.from({ length: 8 }).map((_, i) => (
        <Col
          key={`course-skeleton-${i * 1}`}
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className={clsx({
            'hidden md:block': i >= 4 && i < 6,
            'hidden lg:block': i >= 6,
          })}
        >
          <CourseEnrollmentCardSkeleton isDark={isDark} />
        </Col>
      ))}
    </Row>
  );
};

export default CourseListSkeleton;
